import { Label } from './Label';

export class LabelContext {
  private _name: string;
  public get name(): string {
    return this._name;
  }

  private _labels;

  public constructor(name: string, labels: Label[]) {
    this._name = name;
    this.setLabels(labels);
  }

  public get(labelName: string): Label {
    const label = this._labels[labelName];
    return label ? label : <any>{ labelText: `<<< LABEL ${this._name}:${labelName} >>>` };
  }

  public setLabels(labels: Label[]): void {
    this._labels = {};
    labels.forEach((label: Label) => {
      this._labels[label.labelName.toLowerCase()] = label;
    });
  }
}
